import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  viewChild,
} from '@angular/core';
import { FieldOkListViewComponent, FieldOkListViewConfig } from '@softline/dynamic';

@Component({
  selector: 'soft-lager-lagerplatz-sorted-list-view',
  imports: [FieldOkListViewComponent],
  template: '<soft-field-ok-list-view [config]="config()" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LagerLagerplatzSortedListViewComponent {
  readonly config = input.required<FieldOkListViewConfig>();

  private readonly listView = viewChild(FieldOkListViewComponent);

  constructor() {
    // backend orders by lagerplatz, but JSON.parse re-orders the id-keyed data object — re-sort
    effect(() => {
      this.listView()?.explorer.sort({ property: 'lagerplatz', direction: 'asc' });
    });
  }
}
